import { memo, useMemo } from 'react';
import { Badge, Tooltip } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';

import { PERMISSION_SOURCE } from '../../constants/copy';
import { MAX_VISIBLE_ROLE_TAGS } from '../../constants/permissionSourceTags';
import PermissionSourceTag from './PermissionSourceTag';

/**
 * "via <Role>" tags: the first three show, the rest collapse into "+N" with a tooltip (Oct 8 call).
 *
 * @param {object} props
 * @param {string[]} props.roles Role names.
 */
const RoleSourceTags = ({ roles }) => {
  const { t } = useTranslation('people-access');
  const { visible, hidden } = useMemo(
    () => ({ visible: roles.slice(0, MAX_VISIBLE_ROLE_TAGS), hidden: roles.slice(MAX_VISIBLE_ROLE_TAGS) }),
    [roles],
  );

  return (
    <>
      {visible.map((role) => (
        <PermissionSourceTag key={role} source={PERMISSION_SOURCE.VIA_ROLE} roleName={role} />
      ))}
      {hidden.length ? (
        <Tooltip size="compact" content={hidden.map((role) => t('terms.source.viaRole', { role })).join(', ')}>
          <span tabIndex={0} className="inline-flex">
            <Badge size="small" variant="informative">
              {`+${hidden.length}`}
            </Badge>
          </span>
        </Tooltip>
      ) : null}
    </>
  );
};

export default memo(RoleSourceTags);
